// お知らせの手動データ。
//
// プレスリリースは PR TIMES に載せたものを外部リンクで並べる（WordPress には持たない）。
// WordPress の投稿（/wp/v2/posts）と日付順で混ぜて表示する（news/useNewsItems.js）。

export const PRESS_RELEASES = [
  {
    key: "pr-2026-01-08",
    date: "2026-01-08",
    cat: "プレスリリース",
    title:
      "LEAPS、JTBと連携した「anyBOUND」において第一弾の旅行体験商品を販売開始",
    excerpt:
      "株式会社LEAPSは、株式会社JTBと連携した希少性の高い旅行体験や現物資産の価値を世界に届けるプロジェクト「anyBOUND（エニーバウンド）」において、第一弾となる旅行体験商品の販売を開始しました。",
    href: "https://prtimes.jp/main/html/rd/p/000000003.000162847.html",
    thumb:
      "https://prcdn.freetls.fastly.net/release_image/162847/3/162847-3-d52ab5cb2a592f2e9386c9932a575edb-1600x900.png?format=jpeg&auto=webp&fit=bounds&width=800",
  },
  {
    key: "pr-2025-05-29",
    date: "2025-05-29",
    cat: "プレスリリース",
    title:
      "JTBとLEAPSが、世界中の富裕層に向けた新サイト「anyBOUND」のティザーサイトを本日公開",
    excerpt:
      "株式会社JTBと株式会社LEAPSは、「希少性の高い、世界中の着地型体験コンテンツ」を全世界に向け販売する新サイト「anyBOUND」を今秋立ち上げます。本日、事前登録フォームを実装したティザーサイトを公開します。",
    href: "https://prtimes.jp/main/html/rd/p/000000002.000162847.html",
    thumb:
      "https://prcdn.freetls.fastly.net/release_image/162847/2/162847-2-f304331272344094a9ba5a23d8228934-2276x1280.png?format=jpeg&auto=webp&fit=bounds&width=800",
  },
];

// WordPress の投稿のうち、一覧に出さないもの（上のプレスリリースと中身が重複）。
export const EXCLUDED_POST_TITLES = ["プレスリリースのお知らせ"];

// アイキャッチが無い投稿に当てるサムネイル（タイトルの一部で当てる）。
export const POST_THUMB_OVERRIDES = [
  { match: "未来X", thumb: "/assets/images/news-miraix.webp" },
];

// WordPress が取れなかったとき（通信エラー・プリレンダー時の保険）に出す投稿。
export const FALLBACK_POSTS = [
  {
    key: "wp-mirai-x",
    date: "2024-01-17",
    cat: "お知らせ",
    title:
      "アクセラレーションプログラム未来X JTB Break New Touchpoints Awardを受賞",
    excerpt:
      "アクセラレーションプログラム未来X にてJTB Break New Touchpoints Awardを受賞いたしました。",
    to: "/news/%e3%82%a2%e3%82%af%e3%82%bb%e3%83%a9%e3%83%ac%e3%83%bc%e3%82%b7%e3%83%a7%e3%83%b3%e3%83%97%e3%83%ad%e3%82%b0%e3%83%a9%e3%83%a0%e6%9c%aa%e6%9d%a5x-jtb-break-new-touchpoints-award%e3%82%92%e5%8f%97",
    thumb: "/assets/images/news-miraix.webp",
  },
  {
    key: "wp-g-startup",
    date: "2023-08-10",
    cat: "お知らせ",
    title: "アクセラレーションプログラム G-STARTUP 7batch IncubateTrackへ採択",
    excerpt:
      "株式会社LEAPSは、アクセラレーションプログラム「G-STARTUP」の7batch IncubateTrackへ採択されました。",
    to: "/news/%e3%82%a2%e3%82%af%e3%82%bb%e3%83%a9%e3%83%ac%e3%83%bc%e3%82%b7%e3%83%a7%e3%83%b3%e3%83%97%e3%83%ad%e3%82%b0%e3%83%a9%e3%83%a0-g-startup-7batch-incubatetrack%e3%81%b8%e6%8e%a1%e6%8a%9e",
    thumb: null,
  },
  {
    key: "wp-updraft",
    date: "2023-07-21",
    cat: "お知らせ",
    title: "アクセラレーションプログラムUPDRAFT batch5へ採択",
    excerpt:
      "株式会社LEAPSは、アクセラレーションプログラム「UPDRAFT」のbatch5へ採択されました。",
    to: "/news/%e3%82%a2%e3%82%af%e3%82%bb%e3%83%a9%e3%83%ac%e3%83%bc%e3%82%b7%e3%83%a7%e3%83%b3%e3%83%97%e3%83%ad%e3%82%b0%e3%83%a9%e3%83%a0updraft-batch5%e3%81%b8%e6%8e%a1%e6%8a%9e",
    thumb: null,
  },
];
